export default __webpack_public_path__ + "static/media/preppysport_hover.3b282f1d.png";